import { useMemo } from "react";
import { BaseReportData, SectorView } from "./typesExtendedReport";
import { transformSectors, safeNum, pmrToArrayRaw, PmrBucket } from "./utils/extendedUtils";

export interface ReportVMBase {
    sectors: SectorView[];
    dataSize: number;
    pmrArray: PmrBucket[];
    totals: {
        disbursementTotal: number; //disbursementAmount + withoutDisbursingAmount
    };
    colors: (count: number) => string[];
}

export function useMappedExtendedData(
    data: BaseReportData | null | undefined,
    palette: string[]
): ReportVMBase | null {
    return useMemo(() => {
        if (!data) return null;

        const sectors = transformSectors(data.sectors);
        const pmrArray = pmrToArrayRaw(data.pmr);

        const totals = {
            disbursementTotal:
                safeNum(data.disbursementAmount) + safeNum(data.withoutDisbursingAmount),
        };

        const colors = (count: number) => palette.slice(0, Math.max(0, Math.min(count, palette.length)));

        return {
            sectors,
            dataSize: sectors.length,
            pmrArray,
            totals,
            colors,
        };
    }, [data, palette]);
}